import axios from 'axios';

const clienteAxios = axios.create({
    baseURL: "https://backend.bicicletasjavacolombia.com/api"
});

export default clienteAxios;